import gql from "graphql-tag";

export const CHANGE_PASSWORD = gql`
    mutation ChangePassword($uid: String!, $token: String!, $newPassword: String!) {
        changePassword (input: {
            uid: $uid,
            token: $token,
            newPassword: $newPassword
        }){
            user{
                id
            }
        }
    }
`;
